import React from 'react';
import { Typography } from '@mui/material';
import { Link } from '@mui/material';
import { Link as LinkRouter } from 'react-router-dom';
import { getPolyglot } from '../../../../../../i18n';

export const FreshwatchRegisterMessage = () => {
  const polyglot = getPolyglot();
  return (
    <Typography component="p">
      {polyglot.t('freshwatch.registration.register_message')}{' '}
      <Link to="/signup" component={LinkRouter}>
        {polyglot.t('freshwatch.registration.register_link_title')}
      </Link>
    </Typography>
  );
};
